export default __webpack_public_path__ + "static/media/Night's Shroud.079a02c6.jpg";